import {fileTypes, imageFileTypes} from '@/constants/file-types.js'

/**
 * Image download helper composable
 */
export const useImageDownload = () => {

  //Load image
  const loadImage = async src => {
    const response = await fetch(src)
    const blob = await response.blob()
    const contentType = response.headers.get('Content-Type')
    const dataUrl = URL.createObjectURL(blob)
    return {
      dataUrl,
      contentType,
    }
  }

  //Get image extension based on content type
  const getImageExtension = contentType => {
    switch (contentType) {
      case fileTypes.JPG:
        return 'jpg'
      case fileTypes.PNG:
        return 'png'
      case fileTypes.GIF:
        return 'gif'
      default:
        throw new Error(`Unsupported image type: ${contentType}`)
    }
  }

  //Download image helper
  const downloadImage = async (src, name = 'image') => {

    //Load image and verify
    const {dataUrl, contentType} = await loadImage(src)
    if (!imageFileTypes.includes(contentType)) {
      throw new Error(`Not an image: ${contentType}`)
    }

    //Get extension and create link
    const extension = getImageExtension(contentType)
    const link = document.createElement('a')

    //Set properties
    link.href = dataUrl
    link.download = `${name}.${extension}`

    //Add to body and click
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  //Expose interface
  return {
    downloadImage,
  }
}
